import styled from "styled-components";

export const Container = styled.section`
  padding-top: 15%;
  display: flex;
  justify-content: space-between;
  gap: 8rem;
  background: rgba(0,0,0,0);
  .hero-text{
    & > p{
      font-size: 1.8rem;
    }
      h1 {
    font-size: 7rem;
    white-space: nowrap; /* Mencegah teks terputus */
    overflow: hidden; /* Menyembunyikan teks yang tidak muat */
    text-overflow: ellipsis; /* Menambahkan '...' jika teks terlalu panjang */
  }

    h3{
      color:var(--green);
      margin: 1rem 0;
    }

    
    p.small-resume {
      margin-bottom: 5rem;
    
      font-size : 1.2rem;
      
    }
  }
  .gd{
   color : #FD3A4A;
   
   font-style : ;

   }
// New added
  .social-media{
    display: inline-flex;
    align-items: center;
    justify-content: space-between;
    gap: 1rem;
    padding-top:5rem;
    padding-left:1rem;
    
    }
  .link{
  transition: transform 0.3s ease, filter 0.3s ease;

    &:hover {
        transform: translateY(-10px); /* Animasi ke atas */
  }
    img,span{
      font-size: 3rem;
      width: 3.5rem;
    }
  }


  .button{
    margin-top: 5rem;
    padding: 1.4rem 6rem;
  }

  .hero-image{
    img{
      max-width: 500px;
    }
  }


  @media(max-width: 960px){
    display: block;
    margin-top: 15%;
    .hero-text{

      h1{
        font-size: 3.5rem;
      }
    }
    
    .hero-image{
      display: none;
    }
  }
@media (max-width: 768px) {
    h1 {
      white-space: normal; /* Mengizinkan teks terputus pada baris berikutnya */
    }
  }
  @media(max-width: 600px){
    margin-top: 35%;
     white-space: normal;
  }
  @media(max-width: 480px){
    margin-top: 45%;
     white-space: normal;
  }
`